export default __webpack_public_path__ + "static/media/right_mail_icon.8731f361.svg";